import formsBackendClient from '@/tsClient/servers/noodleQuestionnaires';
import { type CreateDynamicPdfTemplateAssetRequest } from '@/typings/questionnaires-api-models';

const createDynamicPdfTemplateAsset = async (data: CreateDynamicPdfTemplateAssetRequest): Promise<void> => {
  const response = await formsBackendClient.post('/dynamic-pdf-templates-assets', data);
  return response.data;
};

export default createDynamicPdfTemplateAsset;
